<template>

<span class="gamename" v-click-outside="close">

	<a :href="$util.bgg.link.game(gameId)" target="_blank" v-on:click.prevent="toggle" class="gamename-link" ref="link"><slot>{{ name }}</slot></a>

	<transition name="gamename-pop">

		<div class="gamename-menu" v-if="is.open" v-on:click.stop :style="menuStyle">

			<div class="gamename-menu-option" v-on:click="onInfoClick"><i class="fa fa-info-circle"></i>Info Panel</div>
			<div class="gamename-menu-option" v-on:click="onInsightClick"><i class="fa fa-line-chart"></i>Game Insights</div>
			<div class="gamename-menu-option" v-on:click="onBggClick"><i class="fa fa-external-link"></i>BGG Profile</div>

		</div>

	</transition>

</span>

</template>

<script>

import vClickOutside from 'v-click-outside'

export default {

	directives: {
		clickOutside: vClickOutside.directive
	},

	props: ['id', 'game', 'collection'],

	data: function() {

		return {
			is: {
				open: false
			},
			pos: {
				top: 0,
				left: 0
			}
		}

	},

	computed: {

		gameId: function() {

			return this.id || this.game.id

		},

		hasCollectionRename: function() {

			return (this.collection) ? this.collection.rename : false

		},

		name: function() {

			if (this.game.version && !this.game.rename && !this.hasCollectionRename) {

				return (this.game.version.localised) ? this.game.version.localised : this.game.name

			} else {

				return this.hasCollectionRename || this.game.name

			}

		},

		menuStyle: function() {

			return {
				top: this.pos.top + 'px',
				left: this.pos.left + 'px'
			}

		}

	},

	watch: {

		$route: function() {

			this.is.open = false

		}

	},

	methods: {

		toggle: function() {

			if (!this.is.open) {

				var rect = this.$refs.link.getBoundingClientRect()

				this.pos.top = rect.bottom + 6
				this.pos.left = rect.left

			}

			this.is.open = !this.is.open

		},

		close: function() {

			this.is.open = false

		},

		onInfoClick: function() {

			this.is.open = false

			this.$pubsub.$emit('expand.open', {
				id: this.gameId
			})

		},

		onInsightClick: function() {

			this.is.open = false

			this.$router.push({
				name: 'InsightsGame',
				params: {
					type: this.$route.params.type,
					name: this.$route.params.name,
					game: this.gameId
				}
			}).catch(function() {})

		},

		onBggClick: function() {

			this.is.open = false

			this.$util.bgg.open.game(this.gameId)

		}

	}

}

</script>

<style scoped>

.gamename {
	display: inline;
	position: relative;
}

.gamename-link {
	cursor: pointer;
}

.gamename-menu {
	position: fixed;
	background-color: #1a3a4a;
	border-radius: 6px;
	padding: 4px 0;
	z-index: 500000000;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25), 0 2px 8px rgba(0, 0, 0, 0.15);
	white-space: nowrap;
	min-width: 160px;
}

.gamename-menu-option {
	display: flex;
	align-items: center;
	padding: 8px 14px;
	font-size: 13px;
	font-weight: 500;
	color: rgba(255, 255, 255, 0.9);
	cursor: pointer;
	user-select: none;
	transition: background-color 80ms;
}

.is-desktop .gamename-menu-option:hover {
	background-color: rgba(255, 255, 255, 0.1);
	color: #fff;
}

.gamename-menu-option:active {
	background-color: rgba(255, 255, 255, 0.15);
}

.gamename-menu-option .fa {
	width: 20px;
	font-size: 12px;
	color: rgba(255, 255, 255, 0.5);
	flex-shrink: 0;
}

.gamename-pop-enter-active {
	transition: opacity 100ms ease, transform 100ms ease;
}

.gamename-pop-leave-active {
	transition: opacity 80ms ease, transform 80ms ease;
}

.gamename-pop-enter {
	opacity: 0;
	transform: translateY(-4px);
}

.gamename-pop-leave-to {
	opacity: 0;
	transform: translateY(-4px);
}

</style>
